import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table", true)!

  return (_openBlock(), _createBlock(_component_Table, {
    class: "ant-table-striped",
    size: "small",
    columns: _ctx.columns,
    "data-source": _ctx.dataList,
    pagination: _ctx.pagination,
    scroll: { y: _ctx.tableHeight },
    rowKey: "id",
    "row-selection": { selectedRowKeys: _ctx.selectedRowKeys, onChange: _ctx.onSelectChange },
    showSorterTooltip: true,
    onChange: _ctx.handleChangeTable,
    "row-class-name": (_record, index) => (index % 2 === 1 ? 'table-striped' : undefined)
  }, {
    bodyCell: _withCtx(({ column, record }) => [
      (column.dataIndex === 'name')
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "t-line-1",
            href: '#/customers/'+ record.id
          }, _toDisplayString(record.name), 9, _hoisted_1))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["columns", "data-source", "pagination", "scroll", "row-selection", "onChange", "row-class-name"]))
}